import { Modal } from "react-bootstrap";
import { Button } from "../../../app/components";


interface ModalProps {
    show: boolean;
    headerLabel: string;
    onHide: () => void;
    size?: "sm" | "lg" | "xl";
    centered?: boolean;
    className?: string;
    dialogClass?: string;
    children?: React.ReactNode;
    footer?: React.ReactNode; // Para botões customizados
    showButtonsFooter?: boolean;
    showCloseButton?: boolean;
}

export const CustomModal: React.FC<ModalProps> = ({
    show,
    onHide = () => {},
    size = "lg",
    centered = true,
    className,
    dialogClass,
    headerLabel,
    children,
    footer,
    showCloseButton = true,
    showButtonsFooter = true,
    ...rest
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size={size}
            centered={centered}
            className={className}
            dialogClass={dialogClass}
            {...rest}

        >
            <Modal.Header closeButton={showCloseButton}>
                <Modal.Title>{headerLabel}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
            {showButtonsFooter && (
                <Modal.Footer>
                    {footer || (
                        <Button btnColor="secondary" onClick={onHide}>
                            Fechar
                        </Button>
                    )}
                </Modal.Footer>
            )}
        </Modal>
    );
};